// Formatting helpers for the Profit & Loss statement. Cloned from the Sales
// Report's format.ts so the two sections render figures identically (JetBrains
// Mono, tabular alignment). Unlike revenue, P&L subtotals can go negative
// (e.g. Dec 2025 operating profit after the year-end COGS true-up), so `fmt`
// places the minus outside the currency symbol: "-$1,591,803", not "$-1,591,803".

const SYMBOL: Record<string, string> = { EUR: '€', USD: '$' }

export function symbol(currency: string): string {
  return SYMBOL[currency] ?? ''
}

/** Full grouped, negative-aware figure, e.g. €273,385 or -$1,591,803. */
export function fmt(amount: number, currency: string): string {
  const n = Math.round(amount)
  const sign = n < 0 ? '-' : ''
  return sign + symbol(currency) + Math.abs(n).toLocaleString('en-US')
}

/** Compact figure for tight cells, e.g. €531k, $1.7M, -$1.6M. */
export function fmtCompact(amount: number, currency: string): string {
  const s = symbol(currency)
  const sign = amount < 0 ? '-' : ''
  const abs = Math.abs(amount)
  if (abs >= 1_000_000) return sign + s + (abs / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
  if (abs >= 1_000) return sign + s + Math.round(abs / 1_000) + 'k'
  return sign + s + Math.round(abs)
}

/** Margin percentage, e.g. 56.6% or -535.9%. One decimal, no forced plus. */
export function fmtPct(p: number): string {
  return p.toFixed(1) + '%'
}

/** "Jun-26" -> "Jun 2026". Falls back to the raw label if it doesn't parse. */
export function monthLabel(code: string): string {
  const [mon, yy] = code.split('-')
  if (!mon || !yy) return code
  return `${mon} 20${yy}`
}

/** Tailwind utility to render figures in JetBrains Mono with tabular alignment. */
export const MONO = "font-['JetBrains_Mono'] tabular-nums"
